<template>
  <div class="user-set main-panel large">
    <h1 class="panel-title">销售派发色卡分析表</h1>
    <div class="top">
      <div class="form">
        <div class="row">
          <div class="item col-1" :style="{ marginRight: '24px' }">
            <span class="label">时间</span>
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="mini"
              value-format="YYYY-MM-DD"
            />
          </div>
          <div class="item col-1">
            <div class="label" style="width: 60px">客户名:</div>
            <label
              ><input
                type="text"
                style="width: 100px"
                class="cg-input"
                v-model="username"
            /></label>
          </div>
          <div class="item col-3">
            <div class="label">品名</div>
            <el-select
              filterable
              v-model="pmname"
              placeholder="请选择品名"
              style="width: 220px"
              clearable
            >
              <el-option
                v-for="item in pmlist"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="item col-1">
            <div class="label" style="width: 60px">销售人员:</div>
            <label
              ><input
                type="text"
                style="width: 100px"
                class="cg-input"
                v-model="salesPersonName"
            /></label>
          </div>

          <div class="item col-1">
            <div class="form-options">
              <el-button size="small" class="custom-btn" @click="search"
                >查询</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-table :data="list" border style="width: 100%" class="custom-table">
      <el-table-column align="center" prop="salesPersonName" label="销售人员" />
      <el-table-column
        align="center"
        show-overflow-tooltip
        prop="productName"
        label="品名"
      />
      <el-table-column align="center" prop="number" label="派发数量" />
      <el-table-column align="center" prop="nickName" label="派发客户名" />
      <!--加载更多-->
      <template #append>
        <div
          class="load-more"
          :class="{ 'no-more': noMore }"
          v-if="list.length"
          @click="loadMore"
        >
          {{ noMore ? "没有数据了~" : "点击加载下一页" }}
        </div>
      </template>
    </el-table>
  </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance, watch } from "vue";
const { proxy } = getCurrentInstance();

const dateRange = ref([]); //时间范围 [开始日期, 结束日期]
const username = ref("");
const list = ref([]); //表格数据列表
const pmname = ref(""); // 产品编号
const pmlist = ref([]);
const salesPersonName = ref("");

// 分页变量
const pages = ref({ page: 1, size: 50 });
const noMore = ref(false);
const loading = ref(false);

const days = () => {
  const end = new Date();
  const start = new Date();
  start.setMonth(start.getMonth() - 3);
  dateRange.value = [formatDate(start), formatDate(end)];
};

// 缓存值
const STORAGE_KEY = "/publish-clothes/colorcard/colorcardDistributeAnalysis";

// 监听查询条件
watch([pmname, dateRange, username, salesPersonName], () => {
  const searchParams = {
    pmname: pmname.value,
    dateRange: dateRange.value,
    username: username.value,
    salesPersonName: salesPersonName.value,
  };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(searchParams));
});

// 读取缓存回填表单
const loadSearchCache = () => {
  const cacheStr = sessionStorage.getItem(STORAGE_KEY);
  if (cacheStr) {
    try {
      const cache = JSON.parse(cacheStr);
      dateRange.value = cache.dateRange ?? [];
      pmname.value = cache.pmname ?? "";
      username.value = cache.username ?? "";
      salesPersonName.value = cache.salesPersonName ?? "";
    } catch (e) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }
};

const formatDate = (date) => {
  if (!date) return "";
  const time = new Date(date);
  const year = time.getFullYear();
  const month = (time.getMonth() + 1).toString().padStart(2, "0");
  const day = time.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const pmList = async () => {
  try {
    const res = await proxy.$api.Colorcard.gets({});
    if (res.data.code == "200") {
      pmlist.value = res.data.data.list;
    } else {
      proxy.$message.error("获取产品列表失败");
      pmlist.value = [];
    }
  } catch (error) {
    console.error("获取产品列表异常：", error);
    proxy.$message.error("网络错误，获取产品列表失败");
    pmlist.value = [];
  }
};

// 查询：重置页码清空列表
const search = () => {
  pages.value.page = 1;
  noMore.value = false;
  list.value = [];
  getList();
};
// 加载下一页
const loadMore = async () => {
  await getList(true);
};

const getList = async (isLoadMore = false) => {
  if (noMore.value || loading.value) return;
  const beginTime =
    dateRange.value && dateRange.value[0] ? dateRange.value[0] : "";
  const endTime =
    dateRange.value && dateRange.value[1] ? dateRange.value[1] : "";
  const sendata = {
    currentPage: pages.value.page,
    pageSize: pages.value.size,
    productId: pmname.value,
    nickName: username.value,
    salesPersonName: salesPersonName.value,
    beginTime: beginTime,
    endTime: endTime,
  };
  console.log(sendata, "参数");
  try {
    loading.value = true;
    const res = await proxy.$api.Colorcard.getColorcardDistributeAnalysis(
      sendata
    );
    if (res.data.code == 200) {
      const currentData = Array.isArray(res.data.data.list)
        ? res.data.data.list
        : [];
      if (pages.value.page === 1) {
        list.value = currentData;
      } else {
        list.value = [...list.value, ...currentData];
      }
      const total = res.data.data.total;
      noMore.value =
        total != null
          ? list.value.length >= total
          : currentData.length < pages.value.size;
      pages.value.page += 1;
    } else if (!isLoadMore) {
      list.value = [];
      proxy.$message.error("获取列表失败：" + (res.data.msg || "未知错误"));
    }
  } catch (error) {
    console.error("获取列表异常：", error);
    if (!isLoadMore) list.value = [];
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  days();
  loadSearchCache();
  pmList();
  getList();
});
</script>

<style lang="scss" scoped>
@import "./colorcardDistributeAnalysis.scss";
:deep(.custom-btn) {
  background-color: #ffae00 !important;
  border-color: #ffae00 !important;
  color: #333;
}
.main-panel.large {
  background-color: #fff;
}
:deep(.el-dialog) {
  margin-top: 15vh !important;
}
:deep(.el-dialog--center .el-dialog__body) {
  height: 180px;
}
.panel-title {
  color: #666;
}
:deep(.el-select .el-input__inner) {
  background-color: #fff;
}
:deep(.el-select .el-input__inner:focus) {
  background-color: #fff;
}
:deep(.custom-table) {
  background-color: #fff !important;
  .el-table__header-wrapper {
    background-color: #fff !important;
    .el-table__header {
      background-color: #fff !important;
      th {
        background-color: #fff !important;
      }
    }
  }
  .el-table__body-wrapper {
    background-color: #fff !important;
    .el-table__body {
      background-color: #fff !important;
      td {
        background-color: #fff !important;
      }
    }
  }
}
:deep(.el-dialog--center) {
  background-color: #fff !important;
}
/* 和其他页面统一的加载更多样式 */
.load-more {
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #666;
  cursor: pointer;
  &:hover {
    background: #e9ecef;
  }
  &.no-more {
    color: #999;
    cursor: default;
  }
}
</style>
